import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { LoginUser, reset } from "../features/authSlice.js";
import logo from "../logobp3horizontal.png";
import { useLocation } from "react-router-dom";
import exambpp from "../EXAMBPPP-logo.png";
import logobp3 from "../logobp3horizontal.png";
import Header from "./Header.jsx";
import axios from "axios";
import Cookies from "js-cookie";
import { API_URL, API_URL_LOGIN, SECRET_SESSION, PENGAWAS_API_URL, BUILD_VERSION } from "../constants";
import parseHtml from "html-react-parser";
import { encrypt, decrypt_res, encrypt_res, decrypt } from "./shares/GlobalFunction.jsx";
import { UserIcon, KeyIcon, EyeIcon, EyeOffIcon } from "@heroicons/react/solid";
import Webcam from "react-webcam";
import AlertModal from "./shares/AlertModal.js";
import Loader from "./shares/Loader.jsx";
import ResetModal from "./shares/ResetModal.js";
import MessageModal from "./shares/MessageModal.js";
import axiosInstance from "./shares/axiosConfig.js";
import Swal from "sweetalert2";
import SuccessModal from "./shares/SuccessModal.js";
// import Camera from "./shares/Camera.js";

const baseURL = API_URL + "/login/info";

//create function logout and redirect to login
export const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Inform Android that the exam session has ended so it can relax restrictions.
  window.AndroidBridge?.notifyExamFinished();
  dispatch(reset());
  localStorage.removeItem("user");
  localStorage.removeItem("statusJawaban");
  localStorage.removeItem("mulai_ujian");
  localStorage.removeItem("id_ujian");
  localStorage.removeItem("tampilPertanyaan");
  localStorage.removeItem("tampilJawaban");
  localStorage.removeItem("soalAktif");
  localStorage.removeItem("canBack");
  localStorage.removeItem("token");
  localStorage.removeItem("minat_jurusan");
  localStorage.removeItem("minat_jurusan2");
  localStorage.removeItem("idSoal");
  localStorage.removeItem("jenisSoal");
  localStorage.removeItem("statusSave");
  localStorage.removeItem("waktuMengerjakan");
  localStorage.removeItem("statusSeen");
  localStorage.removeItem("kamera");
  localStorage.clear();

  React.useEffect(() => {
    navigate("/login");
  });
};
export const Login = () => {
  const location = useLocation();

  const modalOpen = location.state?.modalOpen || false;
  const [isStopModalOpen, setStopModalOpen] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [effectsCompleted, setEffectsCompleted] = useState(0);
  const [isSuccessOpen, setSuccessReq] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  const [deviceInfo, setDeviceInfo] = useState({
    isMobileDevice: false,
    isTablet: false,
    isDesktop: false,
  });
  const [post, setPost] = React.useState(null);
  React.useEffect(() => {
    axios.post(baseURL).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    });
  }, []);

  React.useEffect(() => {
    if (location.state?.modalOpen) {
      setSuccessReq(true);
  
      // Optional: clear modal state to prevent re-showing on back
      window.history.replaceState({}, document.title)
    }
  }, [location.state])

  React.useEffect(() => {
    if (effectsCompleted >= 1) {
      setIsLoadingPage(false);
    }
  }, [effectsCompleted]);

  useEffect(() => {
    // const handleResize = () => {
    //   setIsMobile(window.innerWidth <= 640);
    // };
    // window.addEventListener("resize", handleResize);
    // // Cleanup event listener on component unmount
    // return () => {
    //   window.removeEventListener("resize", handleResize);
    // };
    const detectDevice = () => {
      // When running inside the ExamBPPP Android app, always treat as desktop
      // so the "Perangkat Tidak Mendukung" mobile block is never shown.
      // Primary check: full bridge (available from CP-07 onward).
      // Fallback check: UA token set by WebViewActivity (available from CP-04 onward).
      const isAndroidApp =
        window.AndroidBridge?.isSecureEnvironment() ||
        navigator.userAgent.includes("JSB8123BKDSB9239BJBJDS89JNSDKK17");
      if (isAndroidApp) {
        setDeviceInfo({ isMobileDevice: false, isTablet: false, isDesktop: true });
        return;
      }

      const width = window.innerWidth;
      const userAgent = navigator.userAgent;

      setDeviceInfo({
        isMobileDevice:
          /Android|iPhone|iPod|Mobile/i.test(userAgent) || width < 640,
        isTablet:
          /iPad|Tablet/i.test(userAgent) || (width >= 640 && width < 1024),
        isDesktop:
          width >= 1024 &&
          !/Android|iPhone|iPad|iPod|Mobile/i.test(userAgent),
      });
    };

    detectDevice();

    window.addEventListener("resize", detectDevice);
    return () => window.removeEventListener("resize", detectDevice);
  }, []);

  const userBaru = Cookies.get("user-baru");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError, isSuccess, isLoading, message } = useSelector(
    (state) => state.auth
  );
  const [isShake, setShake] = useState(false);
  const handleConfirmStop = () => {
    setStopModalOpen(false);
  }

  useEffect(() => {
    if (localStorage.getItem("pesan_henti")){
      setStopModalOpen(true);
    }
    if (user || isSuccess) {
      if (localStorage.getItem("pesan_henti")){
        localStorage.removeItem("pesan_henti");
      }
      const decResponse = JSON.parse(decrypt_res(user.data, SECRET_SESSION));
      const encryptedData = encrypt(JSON.stringify(decResponse));

      //delete cookie userbaru
      Cookies.remove("user-baru");
      if (decResponse.user_agent) {
        const userAgent = navigator.userAgent;
        const browserIdentity = decResponse.user_agent;
        // alert(userAgent);
        if (!userAgent.includes(browserIdentity)) {
          navigate("/blocked", {
            state: {
              userAgent: decResponse.user_agent
            }
          });
          return;
        }
      }

      localStorage.setItem("user", encryptedData);
      localStorage.setItem("token", user.token);
      navigate(`/peserta/confirmdata?username=${username}&event=${decResponse.id_projek}`);
    }

    dispatch(reset());
  }, [user, isSuccess, dispatch, navigate]);

  const handleConfirmSuccess = () => {
    setSuccessReq(false);
  }

  const Auth = (e) => {
    e.preventDefault();
    dispatch(LoginUser({ username, password }));
    setShake(false);
    setTimeout(() => setShake(true), 0);
  };

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const webcamRef = useRef(null);
  // const [capturedImage, setCapturedImage] = useState(null);

  // const capture = (namaFile) => {
  //   if (webcamRef.current) {
  //     const imageSrc = webcamRef.current.getScreenshot({
  //       width: 640,
  //       height: 480,
  //     });
  //     axios.post(API_URL + "/API_URL_PHOTO/save_image_test", {
  //       namaFile: namaFile, //moment().tz("Asia/Bangkok").format("YYYYMMDDHHmmss"),
  //       image: imageSrc,
  //     });
  //   } else {
  //     console.error("Webcam reference is null");
  //   }
  // };

  // const isWebcamAvailable = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     stream.getTracks().forEach((track) => track.stop());
  //     return true;
  //   } catch (err) {
  //     return false;
  //   }
  // };

  // useEffect(() => {
  //   const checkAndCapture = async () => {
  //     if (post && post.camera !== 0 && (await isWebcamAvailable())) {
  //       const interval2 = setInterval(() => {
  //         capture();
  //       }, 10000); // 1 minute interval
  //       return () => clearInterval(interval2);
  //     }
  //   };
  //   checkAndCapture();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [post]);

  if (isLoadingPage) {
    return <Loader destination="/login"/>
  }

  if (deviceInfo.isMobileDevice || deviceInfo.isTablet){
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 p-5">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
          <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-[#E6F2F1]">
            <span className="text-5xl">💻</span>
          </div>

          <h2 className="mb-3 text-center text-2xl font-bold text-[#4F8382]">
            Perangkat Tidak Mendukung
          </h2>

          <p className="mb-6 text-justify leading-7 text-gray-600">
            Pelaksanaan tes hanya dapat dilakukan dengan menggunakan perangkat{" "}
            <span className="font-bold text-[#4F8382]">Laptop</span> atau{" "}
            <span className="font-bold text-[#4F8382]">Komputer Desktop</span>.
          </p>

          <button
            onClick={() => window.location.reload()}
            className="w-full rounded-xl bg-[#4F8382] px-4 py-3 font-semibold text-white transition-all duration-200 hover:bg-[#3F6E6D] active:scale-95 active:bg-[#355D5C]"
          >
            Muat Ulang
          </button>
        </div>
      </div>
    );
  } 

  return (
    <div className="App">
      <SuccessModal
        isOpen={isSuccessOpen}
        onConfirm={handleConfirmSuccess}
        title={"Reset Login"}
        subtitle={"Request Reset Login Berhasil Dikirim"}
        btn_text="OK"
          
      />
      <AlertModal
          isOpen={isStopModalOpen}
          onConfirm={handleConfirmStop}
          title={"Catatan Penghentian Ujian"}
          subtitle={localStorage.getItem("pesan_henti")}
          btn_text="Tutup"
        />
      <div className="flex h-screen">
        {/* {isMobile == 'true' && <Header app_name={post && post.alamat} />} */}
        <div
          className="hidden sm:block w-1/2 sm:w-2/3 h-full"
          style={{
            backgroundImage: "linear-gradient(to top right, #82CECC, #FFFFFF)"
          }}
        >
          <div className="login-container flex flex-col justify-center items-center text-center h-screen">
            {/* Logo */}
            <img
              src={logo}
              alt="Logo"
              className="mx-auto mb-4"
            />

            {/* Title */}
            <p 
              style={{
                fontSize: "30px",
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 700,
                marginBottom: "0px",
                color: "#3B6362"
              }}
            >
              Balai Pengelolaan Pengujian Pendidikan
            </p>

            {/* Subtitle */}
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Planc",
                fontWeight: 200,
                marginBottom: "18px",
                color: "#3B6362"
              }}
            >
              Unggul dalam Bidang Pengujian Pendidikan yang Kredibel dan Berintegritas
            </p>
          </div>
        </div>
        <div
          className="
            flex flex-col items-start
            bg-gradient-to-tr from-[#82CECC] to-white 
            sm:bg-none sm:bg-white
            justify-start h-screen w-full sm:w-1/3
          "
        >
          <div className="flex flex-col justify-end h-[25%] sm:h-2/5 items-start w-full">
            <p
              title="errorMessage"
              className={isError
                ? `error-message ${isShake ? "shake": ""} bg-white border border-b-8 my-4 mx-6 font-bold text-center border-[#BA2120] bb-10 text-red-700 px-6 py-3 rounded-md relative `
                : "bg-red-100 border text-center border-red-400 text-red-700 px-4 py-8 my-4 mx-6 rounded collapse relative "}
              role="alert"
            >
              {parseHtml(message)}
            {/* <button 
              className="absolute top-0 right-1 text-red-700 hover:text-red-900 font-bold text-s focus:outline-none"
              type="button"
              onClick={toggleError}
              >
                
            </button> */}
            </p>
            <img
              src={exambpp}
              className="h-28 sm:h-20 mx-6 self-start"
            ></img>
          </div>
          
          <div
          className="w-full h-[50%] sm:h-3/5 z-10 border-1 border-grey-800 rounded-xl bg-none sm:bg-white px-6 sm:px-6 py-0 sm:py-3 items-center justify-center space-y-6"
          style={{
            // width: "450px",
            // minHeight: "200px",
            // marginTop: "100px",
          }}
        >
          <form onSubmit={Auth} style={{marginTop: "0px"}}>
            {userBaru && (
              <p
                className="bg-blue-100 border text-left border-blue-400 text-blue-700 px-4 py-3 rounded relative"
                role="alert"
              >
                {parseHtml(userBaru)}
              </p>
            )}
            <p className = "max-w-full" style={{
              fontSize: "16px",
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 500,
              // marginBottom: "30px"
            }}>
              Silahkan masuk aplikasi menggunakan ID Peserta dan Kata Sandi yang anda miliki
            </p>

            <p style={{
              marginTop: "30px",
              marginBottom: "5px",
              fontWeight: 700
            }}>ID Peserta</p>
            <div className="flex items-center ">
              {/* <UserIcon className="h-5 w-5 text-gray-800 mr-3" /> */}
              <input
                className="bg-white border-2 mt-2 mb-2 py-4 px-3 rounded-xl w-full"
                type="text"
                // placeholder="ID Peserta"
                aria-label=""
                name="username"
                sty
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <p style={{
              marginTop: "10px",
              marginBottom: "5px",
              fontWeight: 700
            }}>Kata Sandi</p>
            <div className="flex items-center bg-white border-2 mt-2 mb-2 py-4 px-3 rounded-xl w-full">
              {/* <KeyIcon className="h-5 w-5 text-gray-800 mr-3" /> */}
              <input
                className="w-full bg-transparent outline-none border-none"
                type={showPassword ? "text" : "password"}
                placeholder=""
                aria-label=""
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="ml-2 focus:outline-none"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <EyeOffIcon className="h-5 w-5 text-gray-400" />
                ) : (
                  <EyeIcon className="h-5 w-5 text-gray-400" />
                )}
              </button>
            </div>
            

            <div className="text-center mt-2">
              <button
                type="submit"
                className="w-full bg-[#4F8382] hover:bg-[#4F8382] text-white mt-4 py-2 px-4 rounded-2xl"
              >
                {isLoading ? "Loading..." : "Masuk"}
              </button>
            </div>
            {post && post.register_akun === 1 && (
              <div className="text-left mt-4">
                <small>
                  Belum punya akun simulasi ? <br />
                  <NavLink to={"/signup"}>
                    Klik <b>disini</b> untuk membuat <b>Akun Simulasi</b>.
                  </NavLink>
                </small>
              </div>
            )}
            {/* build version 2.0.25 ambil dari constants.js */}
            {deviceInfo.isDesktop && <p className="text-xs text-gray-500 mt-4 mb-4 text-right">
              Build {BUILD_VERSION}
            </p>}
          </form>
        </div>
        <div className="w-full h-[20%] block sm:hidden flex flex-col items-center justify-center">
          <img
              src={logobp3}
              className="h-20 mx-6"
            ></img>
            <p className="text-xs text-gray-500 mt-4 mb-4 text-right">
              Build {BUILD_VERSION}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
// export default Login;
